import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faPlus,
  faPencilAlt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { API_URL } from "./config";
import DashboardLayout from "../components/DashboardLayout/DasboardLayout";

const Billing = () => {
  const navigate = useNavigate();
  const [topUpList, setTopUpList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTopUpData();
  }, []);

  const fetchTopUpData = async () => {
    try {
      const response = await fetch(`${API_URL}/topUp/`);
      const data = await response.json();
      setTopUpList(data.results);
      setIsLoading(false);
    } catch (err) {
      console.log(err.message);
      setIsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-8"
          >
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center">
                <button
                  className="mr-4 text-[#002966] hover:text-[#ffc000] transition-colors duration-200"
                  onClick={() => navigate(-1)}
                >
                  <FontAwesomeIcon icon={faArrowLeft} size="lg" />
                </button>
                <h1 className="text-3xl font-bold text-[#002966]">
                  Account Top Up
                </h1>
              </div>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-[#ffc000] text-[#002966] px-6 py-2 rounded-lg font-semibold flex items-center shadow-lg hover:bg-[#ffcd33] transition-colors duration-200"
                onClick={() => navigate("/AddTopUp")}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Account Top Up
              </motion.button>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-[#002966]">
                      <th className="px-6 py-4 text-left text-white font-semibold">
                        Date
                      </th>
                      <th className="px-6 py-4 text-left text-white font-semibold">
                        Details
                      </th>
                      <th className="px-6 py-4 text-left text-white font-semibold">
                        Dr
                      </th>
                      <th className="px-6 py-4 text-left text-white font-semibold">
                        Cr
                      </th>
                      <th className="px-6 py-4 text-left text-white font-semibold">
                        Balance
                      </th>
                      <th className="px-6 py-4 text-left text-white font-semibold">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="6" className="text-center py-4">
                          <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#ffc000]"></div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      topUpList.map((item) => (
                        <motion.tr
                          key={item.top_up_id}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          className="border-b border-gray-200 hover:bg-gray-50"
                        >
                          <td className="px-6 py-4">{item.date}</td>
                          <td className="px-6 py-4">{item.description}</td>
                          <td className="px-6 py-4 text-red-600">
                            {item.debit}
                          </td>
                          <td className="px-6 py-4 text-green-600">
                            {item.credit}
                          </td>
                          <td className="px-6 py-4 font-semibold">
                            {item.balance}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex space-x-3">
                              <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                className="text-[#002966] hover:text-[#ffc000]"
                                onClick={() =>
                                  navigate(`/EditUser/${item.top_up_id}`)
                                }
                              >
                                <FontAwesomeIcon icon={faPencilAlt} />
                              </motion.button>
                              <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                className="text-red-500 hover:text-red-700"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </motion.button>
                            </div>
                          </td>
                        </motion.tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Billing;
